import { z } from 'zod';
import { Validation } from '@mews/framework';

export enum AccountingCategoriesField {
    AccountingCategory = 'accountingCategoryId',
    RebateAccountingCategory = 'rebateAccountingCategoryId',
    CanceledItemAccountingCategory = 'canceledItemAccountingCategoryId',
}

export const accountingCategoriesSchema = z.object({
    [AccountingCategoriesField.AccountingCategory]: Validation.String.Empty.nullable().default(null),
    [AccountingCategoriesField.RebateAccountingCategory]: Validation.String.Empty.nullable().default(null),
    [AccountingCategoriesField.CanceledItemAccountingCategory]: Validation.String.Empty.nullable().default(null),
});

export type AccountingCategoriesFormValues = z.infer<typeof accountingCategoriesSchema>;
